import { useState } from 'react';
import {
  calendarButtonActiveStyle,
  calendarButtonWrapperStyle,
  calendarFilterButtonStyle,
  calendarIconStyle,
  calendarWrapperStyle,
  closeIconStyle,
  listItemStyle,
  listWrapperStyle
} from './GameDateFilterStyles';

interface GameDateFilterProps {
  dateFilters: string[];
  activeDates: string[];
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  handleDateChange: (date: string) => void;
  closeDate: () => void;
}

const GameDateFilter = ({
  dateFilters,
  activeDates,
  selectedDate,
  setSelectedDate,
  handleDateChange,
  closeDate
}: GameDateFilterProps) => {
  const [showActiveDates, setShowActiveDates] = useState(false);

  const toggleActiveDates = () => {
    setShowActiveDates(!showActiveDates);
  };
  return (
    <>
      <div css={calendarWrapperStyle}>
        <div css={calendarButtonWrapperStyle}>
          {dateFilters?.map((date: string, i: number) => (
            <div
              css={[
                calendarFilterButtonStyle,
                selectedDate === date && calendarButtonActiveStyle
              ]}
              key={date}>
              <span onClick={() => setSelectedDate(date)}>
                {date === 'mega-prize' ? 'Mega Prize' : date}
              </span>
              {dateFilters.length > 3 && i === 0 && selectedDate === date && (
                <span onClick={closeDate}>
                  <img
                    css={closeIconStyle}
                    src={`/webapp-assets/images/ILT/closeIcon.svg?v=${process.env.APP_VERSION}`}
                  />
                </span>
              )}
            </div>
          ))}
        </div>
        <div css={calendarIconStyle} onClick={toggleActiveDates}>
          {activeDates?.length > 0 && (
            <img
              src={`/webapp-assets/images/ILT/calendarIcon.svg?v=${process.env.APP_VERSION}`}
              alt="calendar-icon"
            />
          )}
          {showActiveDates && (
            <ul css={listWrapperStyle}>
              {activeDates?.map((activeDate: string) => (
                <li
                  key={activeDate}
                  onClick={() => {
                    handleDateChange(activeDate);
                    toggleActiveDates();
                  }}
                  css={listItemStyle}>
                  {activeDate}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
};

export default GameDateFilter;
